import clsx from 'clsx'
import {FC, useEffect, useMemo, useRef} from 'react'
import './OrderTableFilter.scss'
import {useDispatch} from 'react-redux'
import {useAppSelector} from '../../../../setup/redux/hooks'
import {
  changeOrderDisplayMode,
  filterDataChange,
  getAll as getAllOrders,
  getOrderStatusList,
  selectOrderFilter,
  selectOrderStatus,
} from '../redux/OrderRedux'
import {SimpleListModel} from '../../../shared/models/SimpleListModel'
import {OrderListFilterModel} from '../models/OrderListFilterModel'
import {KTSVG} from '../../../../_metronic/helpers/components/KTSVG'
import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {ALL_KEY} from '../../../shared/constants'
import {
  getAll as getAllServices,
  selectAllService,
} from '../../../modules/services/redux/serviceRedux'
import {ServiceStatus} from '../../../modules/services/constants'

type Props = {
  className?: string
}
const OrderTableFilter: FC<Props> = () => {
  const intl = useIntl()
  const didRequest = useRef(false)
  const dispatch = useDispatch()
  const orderStatus: SimpleListModel[] = useAppSelector(selectOrderStatus)
  const orderFilter: OrderListFilterModel = useAppSelector(selectOrderFilter)
  const services = useAppSelector(selectAllService)
  const activeServices = useMemo(
    () => services.filter((service) => service.status === ServiceStatus.ENABLE),
    [services]
  )
  useEffect(() => {
    if (!didRequest.current) {
      dispatch(getOrderStatusList())
      dispatch(getAllServices())
      didRequest.current = true
    }
  }, [dispatch])
  const firstActiveServiceId = activeServices[0]?.id
  useEffect(() => {
    if (firstActiveServiceId && orderFilter.serviceId === undefined) {
      dispatch(filterDataChange({...orderFilter, serviceId: firstActiveServiceId, page: 1}))
    }
  }, [firstActiveServiceId, orderFilter, orderFilter.serviceId, dispatch])
  const handleSearchTextChanged = (e?: any | undefined) => {
    if (e) {
      const value = e.target.value
      dispatch(filterDataChange({...orderFilter, text: value, page: 1}))
    } else {
      dispatch(getAllOrders())
    }
  }
  const handleOrderStatusChanged = (e: any) => {
    const value = e.target.value
    if (value > 0) {
      dispatch(filterDataChange({...orderFilter, status: value, page: 1}))
    } else {
      dispatch(filterDataChange({...orderFilter, status: undefined, page: 1}))
    }
  }
  const handleServiceChanged = (serviceId: number) => {
    dispatch(filterDataChange({...orderFilter, serviceId, page: 1}))
  }
  const handleViewModeChange = () => {
    dispatch(changeOrderDisplayMode())
  }
  return (
    <div className='card-header border-0 pt-3 flex-wrap'>
      <div className='d-flex align-items-center'>
        <div className='d-flex align-items-center position-relative me-4'>
          <span className='position-absolute cursor-pointer ms-3' onClick={handleSearchTextChanged}>
            <KTSVG path='/media/icons/duotune/general/gen021.svg' className='svg-icon-3' />
          </span>
          <input
            type='text'
            id='kt_filter_search'
            className='form-control form-control-white form-control-sm w-150px ps-9'
            placeholder='Search'
            onChange={handleSearchTextChanged}
            onKeyDown={(e: any) => {
              if (e.key === 'Enter') {
                handleSearchTextChanged()
              }
            }}
          />
        </div>
      </div>
      <div className='flex-grow-1 d-flex justify-content-center my-2'>
        <div className='nav rounded px-2 py-1'>
          {activeServices.map((service) => {
            const isActive = orderFilter.serviceId === service.id
            return (
              <button
                key={service.id}
                type='button'
                className={clsx(
                  'btn btn-sm me-2 mb-1 px-4 fw-semibold service-filter-btn',
                  isActive ? 'btn-primary text-white' : 'btn-outline-primary text-primary bg-white'
                )}
                onClick={() => handleServiceChanged(service.id)}
              >
                {intl.formatMessage({id: 'SERVICE.SERVICE.' + service.name})}
              </button>
            )
          })}
        </div>
      </div>
      <div className='card-toolbar'>
        <div className='d-flex my-2'>
          <select
            name='status'
            data-hide-search='true'
            className='form-select form-select-white form-select-sm w-125px me-4'
            value={orderFilter.status ?? ALL_KEY}
            onChange={handleOrderStatusChanged}
          >
            <option value={ALL_KEY}>{intl.formatMessage({id: 'SYSTEM.ALL'})}</option>
            {orderStatus &&
              orderStatus.map((item: SimpleListModel) => (
                <option key={item.id} value={item.id}>
                  {intl.formatMessage({id: item.label.toUpperCase()})}
                </option>
              ))}
          </select>

          <Link to='#' className='ms-5 mb-3 align-self-end' onClick={handleViewModeChange}>
            <KTSVG
              path='/media/icons/duotune/general/gen008.svg'
              className=' svg-icon svg-icon-1x svg-icon-dark'
            />
          </Link>
        </div>
      </div>
    </div>
  )
}
export default OrderTableFilter
